import { HttpClientModule } from '@angular/common/http';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, UrlSerializer } from '@angular/router';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { EnvConfig } from './app/shared/models/env-config.model';
import { TrailingSlashUrlSerializer } from './app/shared/trailing-slash-url-serializer';
import { environment } from './environments/environment';

fetch(environment.configUrl, { method: 'get', cache: 'no-cache' })
  .then(r => r.json())
  .then((envConfig: EnvConfig) => {
    if (envConfig.production) enableProdMode();

    bootstrapApplication(AppComponent, {
      providers: [
        importProvidersFrom(
          BrowserModule.withServerTransition({ appId: 'corporate-site' }),
          BrowserAnimationsModule, // 👈 change from provideAnimations()
          HttpClientModule
        ),
        provideRouter(appRoutes),
        { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer },
        { provide: EnvConfig, useFactory: () => new EnvConfig(envConfig) }
      ]
    }).catch(console.error);
  })
  .catch(console.error);
